/*
	© 2019 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module Header
define(
	'Header.Menu.View'
, [
		'Profile.Model'
	,	'SC.Configuration'
	,	'Header.Profile.View'
	,	'Header.Menu.MyAccount.View'
	,	'GlobalViews.HostSelector.View'
	,	'GlobalViews.CurrencySelector.View'

	,	'header_menu.tpl'

	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'underscore'
	,	'jQuery'
	,	'jQuery.sidebarMenu'

	// KODELLA
	,	'Categories'
	,	'Utils'
	]
,	function(
		ProfileModel
	,	Configuration
	,	HeaderProfileView
	,	HeaderMenuMyAccountView
	,	GlobalViewsHostSelectorView
	,	GlobalViewsCurrencySelectorView

	,	header_menu

	,	Backbone
	,	BackboneCompositeView
	,	_
	,	jQuery

	// KODELLA
	,	Categories
	,	Utils
	)
{
	'use strict';

	//@class Header.Menu.View @extends Backbone.View
	return Backbone.View.extend({

		template: header_menu

	,	events: {
			'mouseenter [data-toggle="categories-menu"]': 'menuOpen'
		,	'mouseleave [data-toggle="categories-menu"]': 'menuClose'
		,	'click [data-toggle="categories-menu"]': 'menuClose'

		,	'mouseenter .header-menu-level2-anchor': 'swapImage'
		,	'mouseenter .header-menu-level2 li': 'menuOpen'
		,	'mouseleave .header-menu-level2 li': 'menuClose'

		,	'mouseenter .header-menu-level-container': 'navActive'
		,	'mouseleave .header-menu-level-container': 'navInactive'

		}

	,	menuOpen: function(e)
		{
			if( jQuery(e.currentTarget).hasClass('header-menu-level2-li') ) {
				if( jQuery(e.currentTarget).children('.header-menu-level3').length > 0 ) {
					//jQuery(e.currentTarget).children('.header-menu-level3').addClass('fade-in');
					jQuery(e.currentTarget).children('.header-menu-level3').css('opacity', '100%');
					jQuery(e.currentTarget).children('.header-menu-level3').css('visibility', 'visible');
					//jQuery(e.currentTarget).children('.header-menu-level3').css('display', 'block');
					jQuery(e.currentTarget).children('.header-menu-level3').css('transition', 'opacity 0.3s');
				}
			} else {
				jQuery(e.currentTarget).addClass('open');

				// SWAP IMAGE
				if( jQuery(e.currentTarget).find('a').hasClass('header-menu-level1-anchor') ){
					var href = jQuery(e.currentTarget).find('.header-menu-level1-anchor').attr('href')
					,	categoryImage =	( href.includes('guitars') ) ? this.getCategoryImage('guitars', href, true) : this.getCategoryImage('bass', href, true);

					jQuery(e.currentTarget).find('.header-menu-level-label').html(categoryImage.label);
					jQuery(e.currentTarget).find('.header-menu-level-img img').attr('src', categoryImage.img);
				}
			}
		}

	,	menuClose: function(e)
		{
			if( jQuery(e.currentTarget).hasClass('header-menu-level2-li') ) {
				if( jQuery(e.currentTarget).children('.header-menu-level3').length > 0 ) {
					//jQuery(e.currentTarget).children('.header-menu-level3').removeClass('fade-in');
					jQuery(e.currentTarget).children('.header-menu-level3').css('opacity', '0%');
					jQuery(e.currentTarget).children('.header-menu-level3').css('visibility', 'hidden');
					//jQuery(e.currentTarget).children('.header-menu-level3').css('display', 'none');
					jQuery(e.currentTarget).children('.header-menu-level3').css('transition', 'opacity 0.3s');
				}
			} else {
				jQuery(e.currentTarget).removeClass('open');
			}
		}

	,	swapImage: function(e)
		{
			var href = jQuery(e.currentTarget).attr('href');
			var categoryImage =	( href.includes('guitars') ) ? this.getCategoryImage('guitars', href) : this.getCategoryImage('bass', href);

			jQuery('.header-menu-level-label').html( categoryImage.label );
			jQuery('.header-menu-level-img img').attr('src', categoryImage.img );
		}

	,	getCategoryImage: function(guitarType, href, mainNavigation)
		{
			var	img
			,	label;

			if( mainNavigation ){
				var guitarCategories = (guitarType == 'guitars') ? this.categories[0] || [] : this.categories[1] || [];

				img = guitarCategories.img;
				label = guitarCategories.label;

			} else {
				var guitarCategories = (guitarType == 'guitars') ? this.categories[0].categories || [] : this.categories[1].categories || [];

				for(var i=0; i<guitarCategories.length; i++){
					if( href == guitarCategories[i].href ) {
						img = guitarCategories[i].img;
						label = guitarCategories[i].text;
					}
				}
			}

			return {
				img: img
			,	label: label
			};
		}

	,	navActive: function(e) {
			jQuery(e.currentTarget).closest('[data-toggle="categories-menu"]').children('.header-menu-level1-anchor').addClass('active');
		}

	,	navInactive: function(e) {
			jQuery(e.currentTarget).closest('[data-toggle="categories-menu"]').children('.header-menu-level1-anchor').removeClass('active');
		}

	,	initialize: function ()
		{
			var self = this;
			BackboneCompositeView.add(this);

			this.options.application.on('Configuration.navigationData', this.render, this);

			ProfileModel.getPromise().done(function ()
			{
				self.render();
			});

			// KODELLA
			this.categories = Configuration.navigationData || [];
		}

	,	childViews: {
			'Header.Profile': function ()
			{
				return new HeaderProfileView({
					showMyAccountMenu: false
				,	application: this.options.application
				});
			}
		,	'Header.Menu.MyAccount': function ()
			{
				return new HeaderMenuMyAccountView(this.options);
			}
		,	'Global.HostSelector': function ()
			{
				return new GlobalViewsHostSelectorView();
			}
		,	'Global.CurrencySelector': function ()
			{
				return new GlobalViewsCurrencySelectorView();
			}
		}

		// KODELLA
	,	contextData: {
			'category': function ()
			{
				return Utils.deepCopy(this.model.get('category'));
			}
		}

	,	render: function()
		{
			Backbone.View.prototype.render.apply(this, arguments);
			this.$('[data-type="header-sidebar-menu"]').sidebarMenu();
		}

		// @method getContext
		// @return {Header.Sidebar.View.Context}
	,	getContext: function()
		{
			var profile = ProfileModel.getInstance()
			,	is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
			,	is_loged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
			,	environment = SC.ENVIRONMENT
			,	show_languages = environment.availableHosts && environment.availableHosts.length > 1
			,	show_currencies = environment.availableCurrencies && environment.availableCurrencies.length > 1 && !Configuration.get('header.notShowCurrencySelector');

			console.log("Configuration.navigationData", Configuration.navigationData);
			//console.log("Configuration.navigationData", Configuration.navigationData[0].img);
			//console.log("SC.CATEGORIES", SC.CATEGORIES);

			//var category = Configuration.get('categories');
			//console.log("category", Configuration.navigationData );
			//console.log("Configuration", Configuration);

			//var config = Configuration.get().categories;
			//console.log("config", config);


			//var result = Application.getAllSearchResults('commercecategory');
			//console.log("result", result);

			//var categories = this.model;
			//console.log("categories", categories);

			//this is not good but let's go with it for now
			var newCategories = this.categories;
			var urltoreplace = "/accessories/catalogs";
			var urltoreplacewith = "/catalogs";
			_.each(newCategories, function(tisCateg){
			    if(tisCateg.categories && tisCateg.categories.length > 0){
			        _.each(tisCateg.categories, function(tisSubcateg){
			            if(tisSubcateg.href == urltoreplace){
											tisSubcateg.href = urltoreplacewith;
											if(tisSubcateg.data){
												tisSubcateg.data.hashtag = "#" + urltoreplacewith;
											}
									}
			        })
			    } else {
						if(tisCateg.href == urltoreplace){
								tisCateg.href = urltoreplacewith;
								if(tisCateg.data){
									tisCateg.data.hashtag = "#" + urltoreplacewith;
								}
						}
					}
			});
			// @class Header.Sidebar.View.Context
			return {
				// @property {Array<NavigationData>} navigationItems
				//categories: Configuration.navigationData || []
				categories: newCategories

				// @property {Boolean} showExtendedMenu
			,	showExtendedMenu: !is_loading && is_loged_in
				// @property {Boolean} showLanguages
			,	showLanguages: show_languages
				// @property {Boolean} showCurrencies
			,	showCurrencies: show_currencies
			,	shLogoUrl: Configuration.get('header.logoUrl')
			};
		}
	});

});

